// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Home from "@material-ui/icons/Home";
import EventNote from "@material-ui/icons/EventNote";
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import Grade from "@material-ui/icons/Grade";
import Description from "@material-ui/icons/Description";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import MovieFilter from "@material-ui/icons/MovieFilter";
import AddAlert from "@material-ui/icons/AddAlert";
// core components/views
import DashboardPage from "Pages/Dashboard/screens/Dashboard";
import TeamsList from "Pages/Teams/screens/TeamsList";
import RoundsList from "Pages/Rounds/screens/RoundsList.js";
import GamesList from "Pages/Games/screens/GamesList.js";
import ChampionshipsList from "Pages/Championships/screens/ChampionshipsList.js";
import UsersList from "Pages/Statistics/Users/screens/UsersList.js";
import UsersTeamsList from "Pages/Statistics/UsersTeams/screens/UsersTeamsList.js";
import BestPerformingUsersList from "Pages/Statistics/BestPerformingUsers/screens/BestPerformingUsersList.js";
import BestPlayersList from "Pages/Statistics/BestPlayers/screens/BestPlayersList.js";
import PopularCaptainsList from "Pages/Statistics/PopularCaptains/screens/PopularCaptainsList.js";
import PopularViceCaptainsList from "Pages/Statistics/PopularViceCaptains/screens/PopularViceCaptainsList.js";
import MostBoughtPlayersList from "Pages/Statistics/MostBoughtPlayers/screens/MostBoughtPlayersList.js";
import UsedChipsList from "Pages/Statistics/UsedChips/screens/UsedChipsList.js";
import BoughtChipsList from "Pages/Statistics/BoughtChips/screens/BoughtChipsList.js";
import WildcardsList from "Pages/Statistics/Wildcards/screens/WildcardsList.js";
import PrivateLeaguesList from "Pages/Statistics/PrivateLeagues/screens/PrivateLeaguesList.js";
import StatsMainPage from "Pages/Statistics/StatsMainPage/StatsMainPage.js";
import PalmsList from "Pages/PalmsTransactions/screens/PalmsTransactionsList.js";
import AdsList from "Pages/Advertisements/screens/AdvertisementsList.js";
import Notifications from "Pages/Notifications/screens/Notifications.js";
import Inviters from "Pages/Statistics/Inviters/screens/Inviters.js"
import ChampionshipGames from "Pages/ChampionshipGames/screens/ChampionshipGames.js";
import RegisteredUsersForPeriod from "Pages/Statistics/RegisteredUsersForPeriod/screens/RegisteredUsersForPeriod"
import ActiveUsersForPeriod from "Pages/Statistics/ActiveUsersForPeriod/screens/ActiveUsersForPeriod"
import MostActiveUsersForPeriod from "Pages/Statistics/MostActiveUsersForPeriod/screens/MostActiveUsersForPeriod"

export const statisticsRoutes = [
    {
        path: "/stats/users",
        sidebarName: "Потребители",
        navbarName: "Потребители",
        icon: Description,
        component: UsersList
    },
    {
        path: "/stats/user-teams",
        sidebarName: "Отбори на Потребители",
        navbarName: "Отбори на Потребители",
        icon: Description,
        component: UsersTeamsList
    },
    {
        path: "/stats/best-users",
        sidebarName: "Потребители с най-добър резултат",
        navbarName: "Потребители с най-добър резултат",
        icon: Description,
        component: BestPerformingUsersList
    },
    {
        path: "/stats/best-players",
        sidebarName: "Футболисти с най-много точки",
        navbarName: "Футболисти с най-много точки",
        icon: Description,
        component: BestPlayersList
    },
    {
        path: "/stats/captains-popular",
        sidebarName: "Най-избирани капитани",
        navbarName: "Най-избирани капитани",
        icon: Description,
        component: PopularCaptainsList
    },
    {
        path: "/stats/vicecaptains-popular",
        sidebarName: "Най-избирани вицекапитани",
        navbarName: "Най-избирани вицекапитани",
        icon: Description,
        component: PopularViceCaptainsList
    },
    {
        path: "/stats/most-bought-players",
        sidebarName: "Най-купувани играчи",
        navbarName: "Най-купувани играчи",
        icon: Description,
        component: MostBoughtPlayersList
    },
    {
        path: "/stats/used-chips",
        sidebarName: "Използвани чипове",
        navbarName: "Използвани чипове",
        icon: Description,
        component: UsedChipsList
    },
    {
        path: "/stats/bought-chips",
        sidebarName: "Закупени чипове",
        navbarName: "Закупени чипове",
        icon: Description,
        component: BoughtChipsList
    },
    {
        path: "/stats/wildcards",
        sidebarName: "Използвани Wildcards",
        navbarName: "Използвани Wildcards",
        icon: Description,
        component: WildcardsList
    },
    {
        path: "/stats/private-leagues",
        sidebarName: "Частни лиги",
        navbarName: "Частни лиги",
        icon: Description,
        component: PrivateLeaguesList
    },
    {
        path: "/stats/inviters",
        sidebarName: "Покани",
        navbarName: "Покани",
        icon: Description,
        component: Inviters
    },
    {
        path: "/stats/registered-users-for-period",
        sidebarName: "Нови регистрации",
        navbarName: "Нови регистрации",
        icon: Description,
        component: RegisteredUsersForPeriod
    },
    {
        path: "/stats/active-users-for-period",
        sidebarName: "Активни потребители",
        navbarName: "Активни потребители",
        icon: Description,
        component: ActiveUsersForPeriod
    },
    {
        path: "/stats/most-active-users-for-period",
        sidebarName: "Честота на посещенията",
        navbarName: "Честота на посещенията",
        icon: Description,
        component: MostActiveUsersForPeriod
    },
    { redirect: true, path: "/", to: "/stats/users", navbarName: "Redirect" }

];

const teamRoutes = [
    {
        path: "/teams/1",
        sidebarName: "FPL Fantasy Manager",
        navbarName: "FPL Fantasy Manager",
        icon: Person,
        component: TeamsList,
    },
    {
        path: "/teams/2",
        sidebarName: "Premier League",
        navbarName: "Premier League",
        icon: Person,
        component: TeamsList,
    },
];

const roundRoutes = [
    {
        path: "/rounds/1",
        sidebarName: "FPL Fantasy Manager",
        navbarName: "FPL Fantasy Manager",
        icon: EventNote,
        component: RoundsList
    },
    {
        path: "/rounds/2",
        sidebarName: "Premier League",
        navbarName: "Premier League",
        icon: EventNote,
        component: RoundsList
    },
]

const gameRoutes = [
    {
        path: "/games/1",
        sidebarName: "FPL Fantasy Manager",
        navbarName: "FPL Fantasy Manager",
        icon: DirectionsRun,
        component: GamesList
    },
    {
        path: "/games/2",
        sidebarName: "Premier League",
        navbarName: "Premier League",
        icon: DirectionsRun,
        component: GamesList
    }
]

const adminRoutes = [
    {
        path: "/dashboard",
        sidebarName: "Начало",
        navbarName: "Начало",
        icon: Home,
        component: DashboardPage
    },
    {
        path: "/teams/1",
        sidebarName: "Отбори",
        navbarName: "Отбори",
        icon: Person,
        component: TeamsList,
        listItems: teamRoutes
    },
    {
        path: "/rounds/1",
        sidebarName: "Кръгове",
        navbarName: "Кръгове",
        icon: EventNote,
        component: RoundsList,
        listItems: roundRoutes
    },
    {
        path: "/games/1",
        sidebarName: "Мачове",
        navbarName: "Мачове",
        icon: DirectionsRun,
        component: GamesList,
        listItems: gameRoutes
    },
    {
        path: "/championships",
        sidebarName: "Първенства",
        navbarName: "Първенства",
        icon: Grade,
        component: ChampionshipsList
    },
    {
        path: "/tournaments",
        sidebarName: "Турнири",
        navbarName: "Турнири",
        icon: Grade,
        component: ChampionshipGames
    },
    {
        path: "/palms",
        sidebarName: "Палмс Транзакции",
        navbarName: "Палмс Транзакции",
        icon: MonetizationOn,
        component: PalmsList
    },
    {
        path: "/advertisements",
        sidebarName: "Реклами",
        navbarName: "Реклами",
        icon: MovieFilter,
        component: AdsList
    },
    {
        path: "/notifications",
        sidebarName: "Нотификации",
        navbarName: "Нотификации",
        icon: AddAlert,
        component: Notifications
    },
    {
        path: "/stats",
        sidebarName: "Статистики",
        navbarName: "Статистики",
        icon: Description,
        component: StatsMainPage,
        listItems: statisticsRoutes
    },

    { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];




export const statsRoutes = [
    {
        path: "/dashboard",
        sidebarName: "Начало",
        navbarName: "Начало",
        icon: Home,
        component: DashboardPage
    },
    {
        path: "/teams",
        sidebarName: "Отбори",
        navbarName: "Отбори",
        icon: Person,
        component: TeamsList
    },

    {
        path: "/games",
        sidebarName: "Мачове",
        navbarName: "Мачове",
        icon: DirectionsRun,
        component: GamesList
    },

    { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];

export const ownerRoutes = [
    {
        path: "/dashboard",
        sidebarName: "Начало",
        navbarName: "Начало",
        icon: Home,
        component: DashboardPage
    },
    {
        path: "/teams",
        sidebarName: "Отбори",
        navbarName: "Отбори",
        icon: Person,
        component: TeamsList
    },
    {
        path: "/rounds",
        sidebarName: "Кръгове",
        navbarName: "Кръгове",
        icon: EventNote,
        component: RoundsList
    },
    {
        path: "/games",
        sidebarName: "Мачове",
        navbarName: "Мачове",
        icon: DirectionsRun,
        component: GamesList
    },
    {
        path: "/championships",
        sidebarName: "Първенства",
        navbarName: "Първенства",
        icon: Grade,
        component: ChampionshipsList
    },
    {
        path: "/advertisements",
        sidebarName: "Реклами",
        navbarName: "Реклами",
        icon: MovieFilter,
        component: AdsList
    },
    {
        path: "/notifications",
        sidebarName: "Нотификации",
        navbarName: "Нотификации",
        icon: AddAlert,
        component: Notifications
    },

    { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
]

export default adminRoutes;
